import type { UserNotification } from "~/config/user/user-notifications/utils/types";
import type { MultiSelectStore } from "~/config/zustand/createMultiSelectStore.store";
import { createMultiSelectStore } from "~/config/zustand/createMultiSelectStore.store";

type UserBadgeNotificationsStore = MultiSelectStore<UserNotification>;

const useUserNotificationsStore = createMultiSelectStore<UserNotification>();

export { useUserNotificationsStore };
export type { UserBadgeNotificationsStore };
